import api from './api'

export default {
  login: (email, password, remember = false) =>
    api.post('/auth/login', { email, password, remember }).then(r => r.data),

  register: (payload) =>
    api.post('/auth/register', payload).then(r => r.data),

  verifyEmail: (email, code) =>
    api.post('/auth/verify-email', { email, code }).then(r => r.data),

  resendVerification: (email) =>
    api.post('/auth/resend-verification', { email }).then(r => r.data),

  forgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }).then(r => r.data),

  resetPassword: (payload) =>
    api.post('/auth/reset-password', payload).then(r => r.data),
}
